import { Food } from '@models/food.model';

export class DecreaseFoodQuantity {
  static readonly type = '[Reservation] Decrease Food Quantity';
  constructor(public food: Food | null) {}
}
